import { render } from "./EditQuestionPage.vue?vue&type=template&id=6e928ef4&ts=true"
import script from "./EditQuestionPage.vue?vue&type=script&lang=ts"
export * from "./EditQuestionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__